import React, { FC } from 'react';
import { useDispatch } from 'react-redux';
import { DialogPayload, DialogType } from 'src/redux/types/redux.types';

import Dialog from 'genericComponents/Dialog';
import { BuiltInDialog } from 'genericComponents/Dialog/BuiltInDialogs';
import { closeDialog } from 'src/redux/slices/dialogs.slice';

type Props = DialogPayload;

const AppDialog: FC<Props> = ({
  id,
  closeOnBackdropClick,
  header,
  content,
  data,
  type = DialogType.Custom,
  hideX,
  closeCallBack = () => {},
}) => {
  const dispatch = useDispatch();

  const handleModalAction = () => {
    dispatch(closeDialog(id));
    closeCallBack();
  };

  let children;
  if (type === DialogType.Custom) children = content;
  else
    children = (
      <BuiltInDialog
        type={type as DialogType}
        data={data}
        content={content}
        onConfirm={handleModalAction}
        onClose={handleModalAction}
      />
    );

  return (
    <Dialog
      onBackdropClick={() => {
        if (closeOnBackdropClick) {
          handleModalAction();
        }
      }}
      open
      onClose={handleModalAction}
      header={header}
      type={type}
      hideX={hideX}
    >
      {children}
    </Dialog>
  );
};

AppDialog.defaultProps = {
  type: DialogType.Custom,
};

export default AppDialog;
